import sv_SE from '../../date-picker/locale/sv_SE';
export default sv_SE;



// WEBPACK FOOTER //
// ./components/calendar/locale/sv_SE.tsx